/* @flow */

import React from 'react'
import Select from 'react-select'
import styled from 'styled-components'
import partition from 'lodash/partition'
import sortBy from 'lodash/sortBy'

import { useCustomFonts } from '../../app/entities/hooks'

import { resolveMultipleFontsInBackground } from './CustomFont/helpers'

const FontSelector = ({ ...props }: any) => {
  const [customFonts, isInitialized, { isFetching }] = useFontsForSelector()

  return (
    <DatalessFontSelector
      customFonts={customFonts}
      isFetching={isFetching}
      {...props}
    />
  )
}

const OptionContainer = styled.div`
  font-size: 15px;
  font-family: ${({ family, category }) => `'${family}', ${category}`};
  display: flex;
  align-items: baseline;
`

const OptionExtraLabelContainer = styled.div`
  font-size: 12px;
  color: #ccc;
  margin-left: 10px;
  font-family: PT Sans;
`

export default FontSelector

export const useFontsForSelector = () => {
  const [customFonts, isInitialized, { isFetching }] = useCustomFonts()

  React.useEffect(() => {
    const [googleFonts, customFonts] = partition(
      customFonts,
      font => font.font_type === 'google_font'
    )

    resolveMultipleFontsInBackground({ googleFonts, customFonts })
  }, [customFonts])

  return [customFonts, isInitialized, { isFetching }]
}

export const DatalessFontSelector = ({ customFonts, isFetching, ...props }) => {
  const options = React.useMemo(() => {
    return sortBy(customFonts, 'name')
  }, [customFonts])

  const renderOption = option => {
    if (option.font_type === 'google_font') {
      return (
        <OptionContainer
          family={option.config.family}
          category={option.config.category}
        >
          {option.name}
        </OptionContainer>
      )
    }

    if (option.font_type === 'custom') {
      return (
        <OptionContainer family={option.name} category="sans-serif">
          <span>{option.name}</span>
        </OptionContainer>
      )
    }

    return null
  }

  return (
    <>
      <Select
        isLoading={isFetching}
        options={options}
        optionRenderer={renderOption}
        valueRenderer={renderOption}
        valueKey="id"
        {...props}
      />
    </>
  )
}
